import "./SubmitToCodeModal.css";

import { Dispatch, SetStateAction } from "react";

import { Button, Column, Modal, Row } from "../../../../widget";
import { useSubmitToCodeModal } from "./useSubmitToCodeModal";

interface SubmitToCodeModalProps {
  show: boolean;
  onClose: () => void;
  activityUuid: string;
  activityStatus: string;
  activityRowVersion: number;
  refreshActivityReviews?: boolean;
  setRefreshActivityReviews?: Dispatch<SetStateAction<boolean>>;
}

export const SubmitToCodeModal = ({
  show,
  onClose,
  activityUuid,
  activityStatus,
  activityRowVersion,
  refreshActivityReviews,
  setRefreshActivityReviews,
}: SubmitToCodeModalProps): JSX.Element => {
  const { isLoading, onConfirmClick } = useSubmitToCodeModal({
    activityUuid,
    onClose,
    activityStatus,
    activityRowVersion,
    refreshActivityReviews,
    setRefreshActivityReviews,
  });

  return (
    <Modal show={show} title="Submit to code" onClose={onClose}>
      <Row spacingV="ll" justify="center">
        <Column span={10}>
          <span className="body1">
            Submitting this review will notify the Developer that the process has passed review.
          </span>
        </Column>
      </Row>
      <Row justify="center">
        <Column span={6}>
          <div className="SubmitToCodeModalButtons">
            <Button text="Complete assessment" onClick={onConfirmClick} isLoading={isLoading} />
            <Button variant="secondary" text="Cancel" onClick={onClose} />
          </div>
        </Column>
      </Row>
    </Modal>
  );
};
